module.exports = __webpack_public_path__ + "static/img/role1-c1508018.e429c08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role1-c1508018.png
// module id = ynLG
// module chunks = 1